import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/** oms: buyurtmalar (W — barcha hamkorlar, S — o'z buyurtmalari), mijozlar (W). */
export const workRoutes: RouteObject[] = [
  { path: 'orders', ...page(() => import('./pages/OrdersPage')) },
  { path: 'orders/new', ...page(() => import('./pages/OrderCreatePage')) },
  { path: 'orders/customers', ...page(() => import('./pages/CustomersPage')) },
  { path: 'orders/:id', ...page(() => import('./pages/OrderDetailPage')) },
];

export const sellerRoutes: RouteObject[] = [
  { path: 'orders', ...page(() => import('./pages/OrdersPage')) },
  { path: 'orders/new', ...page(() => import('./pages/OrderCreatePage')) },
  { path: 'orders/:id', ...page(() => import('./pages/OrderDetailPage')) },
];
